function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconsFiltersType = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-27838703-94ee-445d-b2d6-5b1646471a77",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1.15,
    y: 19.06,
    width: 9.64,
    height: 9.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.79,
    cy: 6.51,
    r: 5.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.28 10.42 17.88 20.72 29.04 20.72 23.28 10.42",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsFiltersType, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icons_Filters_Type.c21f8278.svg";
export { ForwardRef as ReactComponent };